/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  accountsListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGet,
} from "../../funcs/accountsListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGet.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request:
    operations
      .ListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGetRequest$inboundSchema,
};

export const tool$accountsListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGet:
  ToolDefinition<typeof args> = {
    name:
      "account-transactions-list-v1",
    description: `List transactions for an account

This endpoint returns an account's transactions, the total transactions for the account found,
and the max transaction index. The max transaction index is used to keep track of the
location in the dataset for pagination purposes.

### How is data retrieved for this endpoint?

Values from the endpoint are created by scraping the transactions from the
ledger canister (and associated archive canisters).

Original tool name: list-account-transactions-ledger-canister-id-accounts-id-transactions-get-api-v1`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] =
        await accountsListAccountTransactionsApiV1LedgersLedgerCanisterIdAccountsIdTransactionsGet(
          client,
          args.request,
          { fetchOptions: { signal: ctx.signal } },
        ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };